/**
 * Parse JWT payload without verification (client-side snapshot only).
 * Backend always re-validates access on mutations.
 */
export function parseJwtPayload(token: string): Record<string, unknown> | null {
  if (!token) return null;
  const parts = token.split(".");
  if (parts.length < 2) return null;

  try {
    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), "=");
    const json = atob(padded);
    return JSON.parse(json) as Record<string, unknown>;
  } catch {
    return null;
  }
}

export function parseTokenAccessFromJwt(token: string) {
  const payload = parseJwtPayload(token);
  if (!payload?.tokenAccess || typeof payload.tokenAccess !== "object") {
    return null;
  }
  return payload.tokenAccess as {
    isOwner: boolean;
    capabilities?: string[];
    brandIds?: string[];
    orgCaps?: string[];
    brands?: Record<string, string[]>;
  };
}
